import { render, staticRenderFns } from "./CalendarNoRounded.vue?vue&type=template&id=70ede84c"
import script from "./CalendarNoRounded.vue?vue&type=script&lang=js"
export * from "./CalendarNoRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports